import {
    deleteRequest,
    putRequest,
    getRequest,
    postRequest,
 } from "../../utils/api";
 const privacy_prefix='/api/price-privacy';
 
 export const apiListPrivays = (data) => {
    return postRequest(privacy_prefix+'/list', data)
 }
 
 export const apiUpdate = (data) => {
    return putRequest(privacy_prefix+'/update', data)
 }
 
 export const apiDelete = (id) => {
    return deleteRequest(privacy_prefix+'/delete/'+id)
 }
 export const apiGet = (id) => {
    return getRequest(privacy_prefix+'/get/'+id)
 }
 
 